<template>
	<div id='DataDiv'>
		<v-Head></v-Head>
		<v-Sidebar></v-Sidebar>
		<div class="content-box" :class="{'content-collapse':collapse}">
			<transition name="move" mode="out-in">
				<keep-alive :include="tagsList">
					<router-view></router-view>
				</keep-alive>
			</transition>
			<el-backtop></el-backtop>
		</div>
	</div>
</template>
<script>
	import vHead from './header.vue';
	import vSidebar from './sidebar.vue';
	export default {
		components: {
			vHead,
			vSidebar,
		},
		data() {
			return {
				tagsList: [],
				collapse: false
			}
		},
		mounted() {
			if (window.sessionStorage.getItem('admin') != '' && window.sessionStorage.getItem('admin') != undefined) {

			} else {
				this.$router.push({
					path: '/login',
				})
			}
			if (this.$route.path == '/') {
				this.$router.push({
					path: '/overview',
				})
			}
			// this.$router.afterEach((to, from, next) => {
			// 	window.scrollTo(0, 0)
			// })
			// $(".content-box").animate({ scrollTop : 0 } , 0)
			// $('#a').scrollTop(0)
			// document.body.scrollTop = document.documentElement.scrollTop = 0;
		}
	}
</script>
<style scoped>
	.content-box {
		min-width: 1200px;
		margin-left: 190px;
	}
</style>



// WEBPACK FOOTER //
// src/components/comment/shouye.vue